import { WebSocketLink } from "@apollo/client/link/ws";
import { SubscriptionClient } from "subscriptions-transport-ws";
import { getAuth } from "./auth";

export default function createWsLink({ wsEndpoint }) {
  const wsClient = new SubscriptionClient(wsEndpoint, {
    reconnect: true,
    connectionCallback() {
      const Authorization = getAuth();
      return Authorization ? { Authorization, headers: { Authorization } } : {};
    }
  });

  const wsLink = new WebSocketLink(wsClient);

  return wsLink;
}
